/** Same Plasmic component id as former Hamdast cheragh widget. */
export const CHERAGH_WIDGET_ID = 'o1maxe7isynnf3v';
export const CHERAGH_APP_KEY = 'cheragh';

export type CheraghFacilityItem = {
  name: string;
  icon: string;
  key?: string;
};

export type CheraghFacilityCategory = {
  title: string;
  items: CheraghFacilityItem[];
};

/** Public shape matching PlasmicHamdastCheraghWidget `data`. */
export type CheraghFacilitiesPublicData = {
  general?: CheraghFacilityItem[];
  access?: CheraghFacilityCategory;
  amenities?: CheraghFacilityCategory;
  other?: CheraghFacilityCategory;
  note?: string[];
  updated_at?: string | null;
  selected?: string[];
  custom?: Array<{ id: string; name: string }>;
};

export function isHamdastCheraghWidget(widget: { app?: string; id?: string } | null | undefined): boolean {
  if (!widget) return false;
  return widget.app === CHERAGH_APP_KEY || widget.id === CHERAGH_WIDGET_ID;
}

export function hasCheraghFacilitiesDisplayData(data: unknown): boolean {
  if (!data || typeof data !== 'object') return false;
  const row = data as CheraghFacilitiesPublicData;
  const generalLen = Array.isArray(row.general) ? row.general.length : 0;
  const noteLen = Array.isArray(row.note) ? row.note.length : 0;
  return generalLen > 0 || noteLen > 0;
}

/** Drop legacy Hamdast cheragh widgets — display now comes from Biko. */
export function withoutHamdastCheraghWidgets<T extends { app?: string; id?: string }>(
  widgets: T[] | null | undefined,
): T[] {
  if (!Array.isArray(widgets)) return [];
  return widgets.filter(widget => !isHamdastCheraghWidget(widget));
}

export type CenterFacilitiesMap = Record<string, CheraghFacilitiesPublicData>;
